﻿import { defineComponent } from 'vue';

import calendar_day from "./calendar_day.vue";

import { Booking } from "../../../../services/booking";
import { Capacity } from "../../../../services/capacity";
import { Product } from "../../../../services/product";

const Book = new Booking();
const Capa = new Capacity();
const Prod = new Product();

import { week_day } from "../../../../objects/front_end/calendar/week_day";

import { product_search } from "../../../../objects/v1_3/product/search/product_search";
import { product_detail_seller_information_month } from '../../../../objects/v1_3/product/product/product_detail_seller_information_month';
import { week } from '../../../../objects/front_end/calendar/week';

export default defineComponent({
    name: "calendar_details",
    components: {
        calendar_day
    },
    emits: [
        "dateSelected", "rangeChange"
    ],
    props: {
    },
    data() {
        return {
            product_search: new product_search() as product_search,
            capacity: [] as week[],
            day_from: new week_day() as week_day,
            day_to: new week_day() as week_day,
            loading: false as boolean,
            calendar_request: 0 as number
        }
    },
    methods: {
        async onCalendarUpdate(selected_filter_tags: [], selected_month: product_detail_seller_information_month) {
            // month changes and filter changes can overlap; only the latest request may update the calendar
            const request = ++this.calendar_request;
            this.loading = true;

            try {
                const product_search = await Prod.Get_Product_Search_Month(selected_filter_tags, selected_month?.year, selected_month?.month);
                if (request != this.calendar_request) {
                    return;
                }

                this.product_search = product_search;
                this.capacity = Capa.Get_Capacity_Search_Week(selected_month?.year, selected_month?.month, this.product_search, this.$store.getters.get_Currency.currency_info.iso_currency_code, Book.Pricing_Age_Category(this.$store));
            } finally {
                if (request == this.calendar_request) {
                    this.loading = false;
                }
            }
        },
        Date_Selected(day: week_day) {
            if (import.meta.env.VITE_DEFAULT_SEARCH_DATE_RANGE == "false") {
                this.$emit("dateSelected", Prod.Get_Product_Search_Day(day.tour_id, this.product_search), day.date);
                return;
            }

            // date range: first click sets the start, second click the end (or a new start when it's earlier);
            // a click after a complete range starts a new one. Compared on output_date (yyyy-mm-dd), so ranges can span months.
            const from = this.day_from.output_date ?? "";
            const to = this.day_to.output_date ?? "";
            const clicked = day.output_date ?? "";

            if (from == "" || to != "" || clicked < from) {
                this.day_from = day;
                this.day_to = new week_day();
            } else {
                this.day_to = day;
            }

            this.$emit("rangeChange", this.day_from, this.day_to);
        },
        Set_Range(day_from: week_day, day_to: week_day) {
            this.day_from = day_from;
            this.day_to = day_to;
            this.$emit("rangeChange", this.day_from, this.day_to);
        },
        Clear_Range() {
            this.day_from = new week_day();
            this.day_to = new week_day();
            this.$emit("rangeChange", this.day_from, this.day_to);
        },
        Is_Date_Selected(day: week_day): boolean {
            const date = day.output_date ?? "";
            const from = this.day_from.output_date ?? "";
            const to = this.day_to.output_date ?? "";

            if (date == "" || from == "") {
                return false;
            }
            if (to == "") {
                return date == from;
            }
            return date >= from && date <= to;
        },
        isAAT(): boolean {
            if (import.meta.env.VITE_DEFAULT_PARENT == "AAT") {
                return true;
            }
            return false;
        }
    },
    mounted() {
    }
})